module.exports = __webpack_public_path__ + "static/media/blue_circle.af3fdec2.png";